import {createContext, useContext} from "react";
import Encounter from "@/encounter/model/Encounter.ts";

export const EncounterContext = createContext<Encounter | null>(null)

export function useEncounter(): Encounter {
    const encounter = useContext(EncounterContext);
    if (!encounter) {
        throw new Error("useEncounter must be used within a Provider")
    }
    return encounter;
}
